import { NgIf } from '@angular/common';
import { Component, computed, OnInit, Signal } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuContent, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatProgressBar } from '@angular/material/progress-bar';
import { TranslatePipe } from '@ngx-translate/core';
import { get } from 'lodash';
import { environment } from '../../../core/environments/environment';
import { EScwAppModule, IScwAppModuleItem, TScwAppModules } from './scw-app-switcher.interface';
import { ScwAppSwitchersStore } from './scw-app-switcher.store';

@Component({
  imports: [
    MatButton,
    MatMenuTrigger,
    MatMenuItem,
    MatMenuContent,
    MatMenu,
    MatIcon,
    NgIf,
    TranslatePipe,
    MatProgressBar,
  ],
  providers: [ScwAppSwitchersStore],
  selector: 'scw-app-switcher',
  styleUrls: ['./scw-app-switcher.component.scss'],
  templateUrl: './scw-app-switcher.component.html',
})
export class ScwAppSwitcherComponent implements OnInit {
  public readonly logoFilePath: string = '../../../assets/images/modules/';
  public moduleItems: IScwAppModuleItem[] = [
    {
      moduleName: EScwAppModule.oeeTracker,
      name: 'OEE Tracker',
    },
    {
      moduleName: EScwAppModule.digitalBoards,
      name: 'Digital Boards',
    },
    {
      moduleName: EScwAppModule.actionTracker,
      name: 'Action Tracker',
    },
    {
      moduleName: EScwAppModule.digitalLogbook,
      name: 'Digital Logbook',
    },
  ];

  public readonly list$: Signal<IScwAppModuleItem[]> = computed(() =>
    this.moduleItems.map((item: IScwAppModuleItem) => {
      const moduleUrl: string | undefined = get(this.store.data$(), item.moduleName);

      if (!moduleUrl) {
        return {
          ...item,
          disabled: true,
        };
      }

      try {
        const parsedEnvUrl = new URL(moduleUrl);

        return {
          ...item,
          disabled: false,
          isCurrentTool: window.location.host === parsedEnvUrl.host,
          link: moduleUrl,
        };
      } catch {
        return {
          ...item,
          disabled: true,
        };
      }
    }),
  );

  constructor(public readonly store: ScwAppSwitchersStore) {}

  public ngOnInit(): void {
    this.store.getUrls();
  }

  public openUrl(link: string, target: '_self' | '_blank'): void {
    if (link) {
      window.open(link, target);
    }
  }
}
